import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// GTM's built-in pageview trigger only fires once, on the initial script
// load. React Router navigates without a full page load, so every route
// change here pushes a virtual pageview event for GTM/GA4 to pick up.
// Renders nothing.
const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'page_view',
      page_path: location.pathname + location.search,
    });
  }, [location]);

  return null;
};

export default AnalyticsTracker;
